'use client';

import { Wizard } from '@/components/wizard/Wizard';

import { CreateSqlEngineFlow } from './CreateSqlEngineFlow';
import {
  defaultCreateSqlEngineWizardState,
  type CreateSqlEngineWizardState,
} from './createSqlEngineWizardState';

interface CreateSqlEngineWizardPanelProps {
  workspaceId: string;
  onAbort: () => void;
  onCreated: () => void;
}

export function CreateSqlEngineWizardPanel({
  workspaceId,
  onAbort,
  onCreated,
}: CreateSqlEngineWizardPanelProps) {
  return (
    <Wizard<CreateSqlEngineWizardState>
      onAbort={onAbort}
      hideBackArrow={true}
      onFinish={async () => {
        onCreated();
        return true;
      }}
      flow={[CreateSqlEngineFlow]}
      initialState={{ ...defaultCreateSqlEngineWizardState, workspaceId }}
      title='Create SQL Engine'
      stepperLabels={[]}
    />
  );
}
